// extracted by mini-css-extract-plugin
export default {"entity":"lsf-entity","entity__info":"lsf-entity__info","entity__warning":"lsf-entity__warning","waiting":"lsf-waiting"};